import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { DateRange } from '@mui/lab/DateRangePicker';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import * as CSS from "csstype";
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { API_URL, AUTHORITY_LIST, AUTHORITY_LIST_USER_ADMIN, AUTHORITY_NO_LIST } from "../../Const";
import ConfirmDialog from "../Dialog";
import GenericTemplate from "../templates/GenericTemplate";
import './style.css';
import { useEffect } from 'react'
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { createdCorporateIdState } from '../../globalStates/createdCorporateId';
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';


// フォームの型
interface UserCreateFormInput {
  email: string,
  user_name: string,
  password: string,
  authority_code: string
}

// バリデーションルール
const schema = yup.object({
  email: yup
    .string()
    .required('必須項目です')
    .email('正しいメールアドレス形式で入力してください'),
  user_name: yup
    .string()
    .required('必須項目です'),
  password: yup
    .string()
    .required('必須項目です') // 必須チェック
    .min(8, '8文字以上入力してください') // 最小文字数8文字チェック
    .max(30, '30文字以下で入力してください') // 最大文字数30文字チェック
    // 英字が含まれているかチェック
    .matches(
      /[a-zA-Z]/,
      '英字を含めてください'
    )
    // 数字含まれているかチェック
    .matches(
      /[0-9]/,
      '数字を含めてください'
    )
    // 半角文字チェック
    .matches(
      /^[\x20-\x7e]*$/,
      '半角文字で入力してください。'
    ),
  authority_code: yup
    .string()
    .required('必須項目です')
})



const useStyles = makeStyles(() =>
  createStyles({
    datePicker: {
      width: '25ch',
    },
  })
);

const msgStyle: CSS.Properties = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#3f3f3f",
  margin: "5px",
  textAlign: "left"
}


const UserCreate: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  const history = useHistory();
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')

  // 権限
  const currencies = jsonlist.user.authority_code === AUTHORITY_NO_LIST.SYSTEM_ADMIN.toString() ?
    AUTHORITY_LIST : AUTHORITY_LIST_USER_ADMIN;

  /*送信パラメータ*/
  const [user_name, setUserName] = useState();
  const [user_name_kana, setUserNameKana] = useState();
  const [user_id, setUserId] = useState();
  const [password, setPassword] = useState();
  const [authority_code, setAuthorityCode] = useState('');
  const [remarks, setRemarks] = useState();
  /* 送信パラメータ値設定 */
  const changeUserName = (e: any) => {
    setUserName(e.target.value);
  }
  const changeUserNameKana = (e: any) => {
    setUserNameKana(e.target.value);
  }
  const changeUserId = (e: any) => {
    setUserId(e.target.value);
  }
  const changePassword = (e: any) => {
    setPassword(e.target.value);
  }
  const changeRemarks = (e: any) => {
    setRemarks(e.target.value);
  }

  //バリデーション設定
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserCreateFormInput>({
    resolver: yupResolver(schema),
  })

  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
  const classes = useStyles();
  const [selectedDate, setSelectedData] = useState<MaterialUiPickersDate>(null);
  // const [currency, setCurrency] = React.useState('');
  const [currency, setCurrency] = useState('');
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const handleChange = (e: any) => {
    setAuthorityCode(e.target.value);
    setCurrency(e.target.value);
  };
  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }

  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });

  const setCreatedCorporateId = useSetRecoilState(createdCorporateIdState)
  const createdCorporateId : string = useRecoilValue(createdCorporateIdState)

  const handleChange2 =
    (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues({ ...values, [prop]: event.target.value });
    };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  // 追加ボタン押下時の処理
  const onSubmit: SubmitHandler<UserCreateFormInput> = (data) => {
    handleClickOpenAdd()
  }

  const [showPassword, setShowPassword] = useState(false);

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理(キャンセル)*/
  const [openCancel, setOpenCancel] = React.useState(false);
  const handleClickOpenCancel = () => {
    setOpenCancel(true);
  };
  const gotoList = () => {
    // 一覧に戻る
    history.push({ pathname: "/Userlist" });
  };
  const setConfirmOpenCancel = (check: any) => {
    setOpenCancel(check)
  };
  /*ダイアログ処理(キャンセル)*/

  /*ダイアログ処理(追加)*/
  const [openAdd, setOpenAdd] = React.useState(false);
  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const addUser = () => {
    if (!loading) {
      setLoading(true);
    }

    openLoading()
    axios.post(API_URL.USER_CREATE,
      {
        "company_id": createdCorporateId || jsonlist.user.company_id,
        "dealer_info_id": createdCorporateId || jsonlist.user.company_id,
        "user_name": user_name,
        "user_name_kana": user_name_kana,
        "user_id": user_id,
        "mail_address": user_id,
        "password": password,
        "available_status": "1",
        "authority_code": authority_code,
        "remarks": remarks
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        // 企業作成から遷移してきた場合、企業一覧に戻る

        if (createdCorporateId) {
          history.push({ pathname: "/Corporatelist" });
          return;
        }

        // 一覧に戻る
        history.push({ pathname: "/Userlist" });
      })
      .catch(error => {
        setLoading(false);
        if (!error.response?.data?.errMessage) return

        if (error.response?.data?.errMessage === '登録済みのユーザーIDです') {
          window.alert('登録済のメールアドレスです。別のメールアドレスを入力してください。')
        }
      })
      .finally(() => {
        closeLoading()
      })

  };
  const setConfirmOpenAdd = (check: any) => {
    setOpenAdd(check)
  };
  /*ダイアログ処理(追加)*/

  useEffect(() => {
    return () => {
      setCreatedCorporateId('')
    }
  }, [])

  // 表示処理
  return (

    <GenericTemplate title="ユーザー 追加">

      <div>
        <ConfirmDialog
          title="入力されているデータで登録しますか？"
          open={openAdd}
          setOpen={setConfirmOpenAdd}
          onConfirm={handleSubmit(addUser)}
          loading={loading}
        >
          入力中のデータは破棄されます
        </ConfirmDialog>
      </div>

      <div>
        <ConfirmDialog
          title="一覧に戻りますか？"
          open={openCancel}
          setOpen={setConfirmOpenCancel}
          onConfirm={gotoList}
          loading={loading}
        >
          入力中のデータは破棄されます
        </ConfirmDialog>
      </div>


      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} >
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">ユーザー名*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              required
              // label="ユーザー名"
              type="string"
              {...register('user_name')}
              error={'user_name' in errors}
              helperText={errors.user_name?.message}
              defaultValue={user_name}
              onChange={changeUserName}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">フリガナ*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              //  label="フリガナ" 
              onChange={changeUserNameKana}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">メールアドレス*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              required
              // label="メールアドレス"
              type="email"
              {...register('email')}
              error={'email' in errors}
              helperText={errors.email?.message}
              onChange={changeUserId}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">パスワード*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <div>
              <TextField
                required
                // label="パスワード"
                type="string"
                {...register('password')}
                error={'password' in errors}
                helperText={errors.password?.message}
                onChange={changePassword}
              />
              <p style={msgStyle} >※半角英数字を必ず1つ含めてください(大文字記号可)<br />
                ※8文字以上30文字以内
                {/* ※以下の記号が利用可能<br />
                ! " # $ % & ' ( ) * + , - . / : ; {'<'} = {'>'} ? @ [ \ ] ^ _ ` {'{'} | {'}'} ~ */}
              </p>
            </div>
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">権限*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              required
              // label="権限"
              type="string"
              {...register('authority_code')}
              error={'authority_code' in errors}
              helperText={errors.authority_code?.message}
              id="outlined-select-currency-native"
              select
              value={currency}
              onChange={handleChange}
              SelectProps={{
                native: true,
              }}
              className="InsText2"
              variant="outlined"
            >
              {currencies.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">備考</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              id="outlined-basic"
              // label="備考"
              variant="outlined"
              className="InsText3"
              multiline={true}
              rows={2}
              maxRows={4}
              onChange={changeRemarks}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={0} margin={0}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={10}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              // onClick={handleClickOpenAdd}
              onClick={handleSubmit(onSubmit)}
            >
              追加
            </Button>
          </Grid>
          <Grid item={true} sm={5} md={6} xs={10}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              // component={Link}
              onClick={handleClickOpenCancel}
            // to="/Userlist"
            >
              キャンセル
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </GenericTemplate>
  );
};

export default UserCreate;